import { useRef } from 'react';
import {
  Button,
  Text,
  VStack,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react';

import { getQuoteTabLabel } from './QuoteLayout';

import type { APIMarketplaceQuoteData } from 'types/api.types';

interface QuoteOwnerDialogProps {
  isOpen: boolean;
  quotes: APIMarketplaceQuoteData[];
  onClose: () => void;
  onConfirm: () => void;
}

const QuoteOwnerDialog = ({
  isOpen,
  quotes,
  onClose,
  onConfirm,
}: QuoteOwnerDialogProps) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const notEditable = quotes.filter((q) => !q.can_edit);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {quotes.length === 1
              ? `Created by ${notEditable[0].broker_name}`
              : 'Some quotes were created by other brokers'}
          </AlertDialogHeader>

          <AlertDialogBody>
            {quotes.length === 1 ? (
              <Text>
                Only the broker who created a quote can edit it. You can open it
                as view only.
              </Text>
            ) : (
              <VStack align="stretch" spacing={1}>
                {notEditable.map((q) => (
                  <Text key={q.id}>
                    {getQuoteTabLabel({
                      id: q.id,
                      line_of_business: q.line_of_business,
                      rfq_ref: q.acturis_rfq_ref || undefined,
                    })}{' '}
                    — created by {q.broker_name}
                  </Text>
                ))}
                <Text pt={2}>
                  These will open as view only.
                  {notEditable.length < quotes.length &&
                    ' Your own quotes stay editable.'}
                </Text>
              </VStack>
            )}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="blue" onClick={onConfirm} ml={3}>
              Open as View Only
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default QuoteOwnerDialog;
